import { useQuery } from '@tanstack/react-query';
import { docusignTemplateKeys, formBuilderApi } from '@/features/quote-and-apply-builder';

export function useDocusignTemplates() {
  return useQuery({
    queryKey: docusignTemplateKeys.lists(),
    queryFn: formBuilderApi.getDocusignTemplates,
    staleTime: 5 * 60 * 1000,
  });
}
